<template>
  <b-card>
    <reserva-timeline :data="reservas" />
    <infinite-loading
      @infinite="infiniteHandler"
    >
      <div slot="no-more">
        Já carregamos todas as suas reservas =)
      </div>
      <no-content-reservas slot="no-results" />
      <div slot="spinner">
        Carregando...
      </div>
    </infinite-loading>
  </b-card>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import ReservaTimeline from './ReservaTimeLine.vue'
import NoContentReservas from './NoContentReservas.vue'

export default {
  components: {
    ReservaTimeline,
    InfiniteLoading,
    NoContentReservas,
  },
  data() {
    return {
      pagination: { page: 1, size: 200 },
    }
  },
  computed: {
    reservas() {
      return this.$store.state.reserva.minhasReservas
    },
  },
  mounted() {
    this.clearReservas()
  },
  methods: {
    infiniteHandler($state) {
      this.fetchReservas(this.pagination).then(res => {
        if (res.data && res.data.length > 0) {
          this.pagination.page += 1
          $state.loaded()
        } else {
          $state.complete()
        }
      })
    },
    clearReservas() {
      this.$store.dispatch('reserva/clearMine')
    },
    fetchReservas(params) {
      return this.$store.dispatch('reserva/fetchAllMine', params)
    },
  },
}
</script>
